import { render, staticRenderFns } from "./c_home_goods_list.vue?vue&type=template&id=b1a4587c&scoped=true"
import script from "./c_home_goods_list.vue?vue&type=script&lang=js"
export * from "./c_home_goods_list.vue?vue&type=script&lang=js"
import style0 from "./c_home_goods_list.vue?vue&type=style&index=0&id=b1a4587c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4587c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a4587c')) {
      api.createRecord('b1a4587c', component.options)
    } else {
      api.reload('b1a4587c', component.options)
    }
    module.hot.accept("./c_home_goods_list.vue?vue&type=template&id=b1a4587c&scoped=true", function () {
      api.rerender('b1a4587c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_goods_list.vue"
export default component.exports